import { Box } from '@mui/material';
import React from 'react';
import AppBar from '../AppBar';

interface AuthenticatedLayoutProps {
  children: React.ReactElement;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
}: AuthenticatedLayoutProps) => {
  return (
    <Box>
      <AppBar />
      <Box>{children}</Box>
    </Box>
  );
};

export default AuthenticatedLayout;
